import { App, Col, InputNumber, Space, Typography } from "antd";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getAttributeFieldQueryByKey,
  getValueFieldQueryByKey,
  usePostField,
} from "./queries";
import { useAuth } from "../../context/AuthContextProvider";
const { Text } = Typography;

const queryKey = "requiredNumOfValues";
const attributeKey = "required_num_of_values";

const RequiredAttributesField = ({ text }) => {
  const { municipalUtility: municipalId } = useAuth();
  const queryClient = useQueryClient();
  const { notification } = App.useApp();
  const { data: numOfRelevant } = useQuery(getAttributeFieldQueryByKey());

  const { data: requiredNumOfAttributes } = useQuery(
    getValueFieldQueryByKey(municipalId)
  );

  const mutationFn = usePostField(queryKey);

  return (
    <>
      <Col>
        <Text>{text}</Text>
      </Col>
      <Col>
        <Space align="center">
          <InputNumber
            min={1}
            max={numOfRelevant}
            controls={false}
            addonAfter={numOfRelevant}
            value={requiredNumOfAttributes}
            disabled={mutationFn.isPending}
            style={{
              width: 70,
            }}
            onPressEnter={(val) => {
              const { value: inputValue } = val.target;
              if (
                Number.isInteger(Number(inputValue)) &&
                inputValue <= numOfRelevant &&
                inputValue >= 1
              ) {
                mutationFn.mutate(
                  { [attributeKey]: inputValue },
                  {
                    onSuccess: () => {
                      notification.success({
                        message: "Aktuallisierung war erfolgreich!",
                      });
                    },
                    onError: () => {
                      notification.error({
                        message: "Aktuallisierung ist fehlgeschlagen!",
                      });
                    },
                  }
                );
              } else {
                notification.error({
                  message: `Ungültiger Wert!`,
                });
                queryClient.invalidateQueries({
                  queryKey: [queryKey],
                });
              }
            }}
          />
        </Space>
      </Col>
    </>
  );
};

export default RequiredAttributesField;
